export default "__VITE_ASSET__CZ4xxCfs__"